module.exports = __webpack_public_path__ + "img/Life-Insurance-Guide_Products_Final-Expense-Icon.45552d3e.svg";